<div class="mat-dialog-device-details">
  <form [formGroup]="userForm">
    <div mat-dialog-title class="dialog-title">
      <h2>{{headerName}}</h2>
      <button mat-icon-button aria-label="close dialog" [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="mat-typography">
      <div class="move-site-form">
        <mat-grid-list cols="2" rowHeight="80px">
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label>Potential ID</mat-label>
                <input matInput type="text" placeholder="Enter Potential ID" name="potentialId"
                  formControlName="potentialId" />
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.potentialId}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label>Farm Type </mat-label>
                <mat-select name="farmType" formControlName="farmType" (ngModelChange)="handleSelectFarmType($event)">
                  <mat-option *ngFor="let farmTyp of farmTypeData;"
                    value="{{farmTyp.value}}">{{farmTyp.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.farmType}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
        <div class="nots-text"> </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button class="move-btn" type="submit" (click)="moveSite()">
        Move
      </button>
    </mat-dialog-actions>
  </form>
</div>